import * as i0 from '@angular/core';
import { Injectable, Inject, Component, ViewChild, Input, NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import * as i1 from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import * as i1$1 from '@upr-web-primer/app-utils';
import { param, restoreScrollPosition, AutoSubscription, AppEnvironmentService } from '@upr-web-primer/app-utils';
import * as i5 from '@upr-web-primer/digital-data';
import * as i4 from '@upr-web-primer/gds-data-model';
import * as i6 from '@upr-web-primer/spinner';
import * as i3 from '@upr-web-primer/tcm-service';
import { WINDOW } from '@upr-web-primer/window';
import { get, debounce, throttle, mapValues } from 'lodash-es';
import { Subject, BehaviorSubject, fromEvent, Subscription, fromEventPattern, take, switchMap, distinctUntilChanged } from 'rxjs';
import { GdsButtonTypes, AvailableGdsThemes } from '@upr-gds-web/components';
import * as i5$1 from '@angular/common';
import { DOCUMENT, CommonModule } from '@angular/common';
import * as i2 from '@upr-web-primer/gds-button-events';
import { GdsButtonEventsService, GdsButtonEventsModule } from '@upr-web-primer/gds-button-events';
import { __decorate, __metadata } from 'tslib';
import { Tween, Easing, update } from '@tweenjs/tween.js';
import * as i8 from '@upr-web-primer/gds-common-utility';
import { GdsCommonUtilityService } from '@upr-web-primer/gds-common-utility';
import * as i1$2 from '@upr-web-primer/gds-filter-list';
import { GdsInteractiveMapFilterService, GdsFilterListService } from '@upr-web-primer/gds-filter-list';
import * as i3$1 from '@upr-web-primer/page-labels';
import { PageLabelsResolver } from '@upr-web-primer/page-labels';
import * as i1$3 from '@upr-web-primer/modal';

// TODO: DELETE THIS FILE
const _c0 = ["gdsMapContainer"];
function TilePinComponent_article_0_tcm_picture_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "tcm-picture", 8);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("data", ctx_r1.data == null ? null : ctx_r1.data.Content == null ? null : ctx_r1.data.Content.TileImage)("settings", ctx_r1.tcmPictureSettings);
  }
}
function TilePinComponent_article_0_h3_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "h3", 9);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("innerHTML", ctx_r1.data == null ? null : ctx_r1.data.Content == null ? null : ctx_r1.data.Content.Heading, i0.ɵɵsanitizeHtml);
  }
}
function TilePinComponent_article_0_span_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 10);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("innerHtml", ctx_r1.txtReadMore, i0.ɵɵsanitizeHtml);
  }
}
function TilePinComponent_article_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "article", 1)(1, "div", 2);
    i0.ɵɵtemplate(2, TilePinComponent_article_0_tcm_picture_2_Template, 1, 2, "tcm-picture", 3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 4);
    i0.ɵɵtemplate(4, TilePinComponent_article_0_h3_4_Template, 1, 1, "h3", 5);
    i0.ɵɵelementStart(5, "tcm-anchor", 6);
    i0.ɵɵlistener("click", function TilePinComponent_article_0_Template_tcm_anchor_click_5_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.closeMapModal($event));
    });
    i0.ɵɵtemplate(6, TilePinComponent_article_0_span_6_Template, 1, 1, "span", 7);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.data == null ? null : ctx_r1.data.Content == null ? null : ctx_r1.data.Content.TileImage);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.data == null ? null : ctx_r1.data.Content == null ? null : ctx_r1.data.Content.Heading);
    i0.ɵɵadvance();
    i0.ɵɵproperty("overwriteUrl", ctx_r1.data == null ? null : ctx_r1.data.PageUrl)("transclude", true)("ariaLabel", ctx_r1.txtReadMore + " - " + (ctx_r1.data == null ? null : ctx_r1.data.Content == null ? null : ctx_r1.data.Content.Heading));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.txtReadMore);
  }
}
function GdsMapInteractiveComponent_upr_google_map_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "upr-google-map", 1);
    i0.ɵɵpipe(1, "async");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("gdsMapContainerData", ctx_r0.data)("lat", ctx_r0.gdsMapService.lat)("lng", ctx_r0.gdsMapService.lng)("apiKey", ctx_r0.gdsMapService.apiKey)("zoom", ctx_r0.gdsMapService.zoom)("mapType", ctx_r0.gdsMapService.mapType)("pageView", ctx_r0.pageView)("modalOpen", i0.ɵɵpipeBind1(1, 9, ctx_r0.showModal$))("theme", ctx_r0.theme);
  }
}
const Cf5TitleData = {
  eyebrow: 'This is some tiny text.',
  heading: 'Take a Look Around Universals Islands of Adventure™`',
  description: 'Lorem ipsum dolor sit amet, <a href="https://www.universalorlando.com" target="_blank"> consectetur adipiscing elit.</a> vitae faucibus metus erat non mi.',
  legalDescription: 'Lorem <a href="https://www.w3.org/TR/" target="_blank">link</a>, consectetur adipiscing elit.',
  backgroundImage: {
    mobile: './assets/images/cf5-center-bg-sm.png',
    tablet: './assets/images/cf5-center-bg-md.png',
    desktop: './assets/images/cf5-center-bg-lg.png',
    alt: 'Content Feature Five Background'
  },
  backgroundColor: 'blue',
  fontColor: 'light-font',
  buttons: [{
    type: 'primary',
    href: 'https://google.com',
    label: 'View Gallery'
  }, {
    type: 'tertiary',
    href: '',
    label: ''
  }]
};
const GdsMapContainerSampleData = {
  heading: 'Resort Map',
  closeMapModalAriaLabel: 'Close Map Modal',
  expandButtonAriaLabel: 'Expand Map',
  filterButtonAriaLabel: 'Open Filters',
  mobileComponents: [{
    selector: 'gds-cf5-title',
    data: {
      ...Cf5TitleData,
      eyebrow: '',
      heading: 'Interactive Map',
      description: '',
      legalDescription: 'Find rides, shopping, dining, events and more for your perfect visit using the interactive map',
      buttons: [{
        type: 'primary',
        label: 'Open Interactive Map',
        target: 'map-modal',
        customEventDetail: {
          pageView: true
        }
      }]
    }
  }]
};
const GdsMapContainerActiveFilterZoneSampleData = {
  filterChips: [{
    label: 'Filter 1',
    ariaLabel: 'Remove Filter 1'
  }, {
    label: 'Filter 2',
    ariaLabel: 'Remove Filter 2'
  }, {
    label: 'Filter 3',
    ariaLabel: 'Remove Filter 3'
  }, {
    label: 'Filter 4',
    ariaLabel: 'Remove Filter 4'
  }, {
    label: 'Filter 5',
    ariaLabel: 'Remove Filter 5'
  }, {
    label: 'Filter 6',
    ariaLabel: 'Remove Filter 6'
  }, {
    label: 'Filter 7',
    ariaLabel: 'Remove Filter 7'
  }, {
    label: 'Filter 8',
    ariaLabel: 'Remove Filter 8'
  }, {
    label: 'Filter 9',
    ariaLabel: 'Remove Filter 9'
  }, {
    label: 'Filter 10',
    ariaLabel: 'Remove Filter 10'
  }, {
    label: 'Filter 11',
    ariaLabel: 'Remove Filter 11'
  }, {
    label: 'Filter 12',
    ariaLabel: 'Remove Filter 12'
  }, {
    label: 'Filter 13',
    ariaLabel: 'Remove Filter 13'
  }],
  deletedAriaLabel: 'Remove Filter'
};
const toggleSampleData = {
  label: 'Are you ready ?',
  positiveLabel: 'On',
  negativeLabel: 'Off',
  icon: 'hhn'
};
const toggleDataSample = {
  ...toggleSampleData,
  customEventDetail: {
    key: 'toggle.key.1'
  },
  icon: 'express-color',
  label: 'Express Pass',
  initialToggle: false,
  analytics: 'test'
};
const selectionChipsSampleData = {
  type: 'multi',
  header: {
    heading: 'Categories',
    description: 'Single selectable toggle buttons',
    button: {
      label: '',
      ariaLabel: ''
    }
  },
  items: [{
    ariaLabel: 'select toggle button for Universal Orlando, Florida Shows and Entertainment',
    href: '',
    label: 'Universal Orlando, Florida Shows and Entertainment',
    isActive: false,
    customEventDetail: {
      key: 'sc.key.0'
    }
  }, {
    href: '',
    ariaLabel: 'select toggle button for Shopping',
    label: 'Shopping',
    isActive: false,
    customEventDetail: {
      key: 'sc.key.1'
    }
  }, {
    href: '',
    ariaLabel: 'select toggle button for Shows and Entertainment',
    label: 'Shows and Entertainment',
    isActive: false,
    customEventDetail: {
      key: 'sc.key.2'
    }
  }, {
    href: '',
    ariaLabel: 'select toggle button for Rides and Attractions',
    label: 'Rides and Attractions',
    isActive: false,
    customEventDetail: {
      key: 'sc.key.3'
    }
  }, {
    href: '',
    ariaLabel: 'select toggle button for 1',
    label: '1',
    isActive: false,
    customEventDetail: {
      key: 'sc.key.4'
    }
  }, {
    href: '',
    ariaLabel: 'select toggle button for Universal Studios Hollywood',
    label: 'Universal Studios Hollywood',
    isActive: false,
    customEventDetail: {
      key: 'sc.key.5'
    }
  }, {
    href: '',
    ariaLabel: 'select toggle button for Merchandise',
    label: 'Merchandise',
    isActive: false,
    customEventDetail: {
      key: 'sc.key.6'
    }
  }, {
    href: '',
    ariaLabel: 'select toggle button for Movie timings',
    label: 'Movie timings',
    isActive: false,
    customEventDetail: {
      key: 'sc.key.7'
    }
  }, {
    href: '',
    ariaLabel: 'select toggle button for Things to do',
    label: 'Things to do',
    isActive: false,
    customEventDetail: {
      key: 'sc.key.8'
    }
  }]
};
const checkboxSectionsSampleData = [{
  showInAccordion: false,
  heading: 'Checkbox Section 1',
  description: 'Description goes here',
  checkboxes: [{
    customEventDetail: {
      key: 'checkbox.key.1'
    },
    primaryLabel: '3-D/4-D Experience',
    checked: ''
  }, {
    customEventDetail: {
      key: 'checkbox.key.2'
    },
    primaryLabel: 'Kid Friendly',
    checked: ''
  }, {
    customEventDetail: {
      key: 'checkbox.key.3'
    },
    primaryLabel: 'Live-Action Shows',
    checked: ''
  }, {
    customEventDetail: {
      key: 'checkbox.key.4'
    },
    primaryLabel: 'Motion Simulation',
    checked: ''
  }, {
    customEventDetail: {
      key: 'checkbox.key.5'
    },
    primaryLabel: 'Multi-Person Family',
    checked: ''
  }]
}, {
  showInAccordion: true,
  heading: 'Checkbox Section 2',
  description: 'Description goes here',
  checkboxes: [{
    customEventDetail: {
      key: 'checkbox.key.6'
    },
    primaryLabel: '3-D/4-D Experience 2',
    checked: ''
  }, {
    customEventDetail: {
      key: 'checkbox.key.7'
    },
    primaryLabel: 'Kid Friendly 2',
    checked: ''
  }, {
    customEventDetail: {
      key: 'checkbox.key.8'
    },
    primaryLabel: 'Live-Action Shows 2',
    checked: ''
  }, {
    customEventDetail: {
      key: 'checkbox.key.9'
    },
    primaryLabel: 'Motion Simulation 2',
    checked: ''
  }, {
    customEventDetail: {
      key: 'checkbox.key.10'
    },
    primaryLabel: 'Multi-Person Family 2',
    checked: ''
  }]
}, {
  showInAccordion: true,
  heading: 'Checkbox Section 3',
  description: 'Description goes here',
  checkboxes: [{
    customEventDetail: {
      key: 'checkbox.key.11'
    },
    primaryLabel: '3-D/4-D Experience 3'
  }, {
    customEventDetail: {
      key: 'checkbox.key.12'
    },
    primaryLabel: 'Kid Friendly 3'
  }, {
    customEventDetail: {
      key: 'checkbox.key.13'
    },
    primaryLabel: 'Live-Action Shows 3'
  }, {
    customEventDetail: {
      key: 'checkbox.key.14'
    },
    primaryLabel: 'Motion Simulation 3'
  }, {
    customEventDetail: {
      key: 'checkbox.key.15'
    },
    primaryLabel: 'Multi-Person Family 3'
  }]
}];
const checkboxSections = checkboxSectionsSampleData.map(data => {
  return {
    data,
    type: 'checkbox'
  };
});
const GdsFilterListSidebarSampleData = {
  heading: 'All Filters',
  applyButton: {
    label: 'Apply',
    type: GdsButtonTypes.primary,
    ariaLabel: 'Apply Filters'
  },
  clearButton: {
    label: 'Clear Filters',
    type: GdsButtonTypes.tertiary,
    ariaLabel: 'Clear Filters'
  },
  sections: [[{
    type: 'selectionChip',
    data: selectionChipsSampleData
  }, {
    type: 'toggle',
    data: toggleDataSample
  }, ...checkboxSections]],
  clickApplyAriaLabel: 'Press apply to activate filters',
  appliedAriaLabel: 'filters applied',
  clearedAriaLabel: 'filters cleared'
};
var GdsInteractiveMapModalType;
(function (GdsInteractiveMapModalType) {
  GdsInteractiveMapModalType["GLOBAL"] = "global";
  GdsInteractiveMapModalType["PAGE"] = "page";
})(GdsInteractiveMapModalType || (GdsInteractiveMapModalType = {}));
const GDS_INTERACTIVE_MAP_REPLACED_DEFAULTS = {
  map: {
    api_key: param('$googlemap.apikey$'),
    map_id: param('$map.map_id$'),
    map_type: param('$map.map_type$'),
    bounds: {
      east: param('$map.bounds.east$'),
      north: param('$map.bounds.north$'),
      south: param('$map.bounds.south$'),
      west: param('$map.bounds.west$')
    },
    center: {
      lat: param('$map.center.lat$'),
      lng: param('$map.center.lng$')
    },
    global_content_id: param('$map.global_content_id$'),
    zoom: {
      default: param('$map.zoom.default$'),
      min: param('$map.zoom.min$'),
      max: param('$map.zoom.max$'),
      levels: {
        parks: param('$map.zoom.levels.parks$'),
        land: param('$map.zoom.levels.land$'),
        poi: param('$map.zoom.levels.poi$'),
        poi_labels: param('$map.zoom.levels.poi_labels$'),
        flyTo: param('$map.zoom.levels.flyTo$')
      }
    },
    tiles: {
      range: {
        14: param('$map.tiles.range.14$'),
        15: param('$map.tiles.range.15$'),
        16: param(`$map.tiles.range.16$`),
        17: param(`$map.tiles.range.17$`),
        18: param(`$map.tiles.range.18$`),
        19: param(`$map.tiles.range.19$`),
        20: param(`$map.tiles.range.20$`)
      },
      url: param('$map.tiles.url$')
    }
  }
};
const GDS_INTERACTIVE_MAP_DEFAULTS = {
  map: {
    api_key: 'AIzaSyA449w8FMEW2t1rxYzabrjOQ7pd15QYyas',
    map_id: '2dda96ba9adc1d84',
    map_type: 'universalStudios',
    bounds: {
      north: '28.500660939432926',
      south: '28.444538856393752',
      west: '-81.49657652329446',
      east: '-81.43452105003176'
    },
    center: {
      lat: '28.47372',
      lng: '-81.466373'
    },
    global_content_id: '',
    zoom: {
      default: '15',
      min: '14',
      max: '20',
      levels: {
        parks: '16.5',
        land: '17',
        poi: '17.6',
        poi_labels: '19',
        flyTo: '19.5'
      }
    },
    tiles: {
      range: {
        14: '4483|4485|6838|6840',
        15: '8967|8970|13677|13680',
        16: '17935|17940|27354|27360',
        17: '35870|35880|54706|54720',
        18: '71734|71761|109412|109440',
        19: '143468|143522|218824|218880',
        20: '286936|287044|437648|437760'
      },
      url: '//servicesdev.universalorlando.com/api/MapTiles'
    }
  }
};
class GdsInteractiveMapService {
  constructor(window, router, appEnvSrv, tcmService, gdsDataModelService, route, appDataLayer, spinner, digitalData) {
    this.window = window;
    this.router = router;
    this.appEnvSrv = appEnvSrv;
    this.tcmService = tcmService;
    this.gdsDataModelService = gdsDataModelService;
    this.route = route;
    this.appDataLayer = appDataLayer;
    this.spinner = spinner;
    this.digitalData = digitalData;
    this.mapDataChanged = new Subject();
    this.mapDataChanged$ = this.mapDataChanged.asObservable();
    this.mapId = '';
    this.apiKey = '';
    this.bgColor = '';
    this.tilesUrl = '';
    this.filterZoneData = GdsMapContainerActiveFilterZoneSampleData;
    this.sideBarData = GdsFilterListSidebarSampleData;
    this.isFilterListView = false;
    this.mapType = '';
    this.minZoom = 0;
    this.maxZoom = 0;
    this.lat = 0;
    this.lng = 0;
    this.zoom = 0;
    this.bounds = {};
    this._globalMapData = new BehaviorSubject(null);
    this.globalMapData$ = this._globalMapData.asObservable();
    this.appEnvSrv.addDefaultValues(GDS_INTERACTIVE_MAP_DEFAULTS, GDS_INTERACTIVE_MAP_REPLACED_DEFAULTS);
    this.gdsMapConfig = this.appEnvSrv.getEnvVariables('map');
    this.apiKey = this.gdsMapConfig.api_key;
    this.mapId = this.gdsMapConfig.map_id;
    this.mapType = this.gdsMapConfig.map_type;
    this.tilesUrl = this.gdsMapConfig.tiles.url;
    this.lat = parseFloat(this.gdsMapConfig.center.lat);
    this.lng = parseFloat(this.gdsMapConfig.center.lng);
    this.minZoom = parseFloat(this.gdsMapConfig.zoom.min);
    if (this.isSmallScreen()) {
      this.minZoom--;
    }
    this.maxZoom = parseFloat(this.gdsMapConfig.zoom.max);
    this.zoom = parseFloat(this.gdsMapConfig.zoom.default);
    this.bounds = {
      east: parseFloat(this.gdsMapConfig.bounds.east),
      north: parseFloat(this.gdsMapConfig.bounds.north),
      south: parseFloat(this.gdsMapConfig.bounds.south),
      west: parseFloat(this.gdsMapConfig.bounds.west)
    };
    this.tileRange = this.gdsMapConfig.tiles.range;
    this.initGlobalListeners();
  }
  async openModal(isPageView, href, isFilterListView) {
    // Prevent global map from opening when there is no data available.
    if (!isPageView && !this._globalMapData.getValue()) {
      await this.loadGlobalMap();
    }
    const mapModal = isPageView ? GdsInteractiveMapModalType.PAGE : GdsInteractiveMapModalType.GLOBAL;
    const queryParamObj = {};
    if (href) {
      href.substring(href.indexOf('?') + 1).split('&').forEach(e => {
        const param = e.split('=');
        queryParamObj[param[0]] = param[1];
      });
    }
    // Extra step to force mapModal as first parameter
    let queryParams = this.route.snapshot.queryParams;
    if (isFilterListView) {
      this.isFilterListView = true;
      queryParams = {
        ...queryParams,
        isFilterListView
      };
    }
    this.router.navigate([], {
      queryParams: {
        ...queryParamObj,
        mapModal,
        ...queryParams
      },
      replaceUrl: true
    });
  }
  closeModal() {
    this.isFilterListView = false;
    this.router.navigate([], {
      queryParams: {
        mapModal: null,
        isFilterListView: null,
        gmapFilters: null
      },
      replaceUrl: true,
      queryParamsHandling: 'merge'
    });
  }
  mapModalToggled(modalOpen, isPageView) {
    if (modalOpen) {
      this.openModal(isPageView);
    } else {
      this.closeModal();
    }
  }
  appendMapCardIdToQueryParams(mapCard) {
    restoreScrollPosition(() => {
      return this.router.navigate([], {
        queryParams: {
          mapCard
        },
        replaceUrl: true,
        queryParamsHandling: 'merge'
      });
    });
  }
  async loadGlobalMap() {
    if (this.gdsMapConfig.global_content_id && !this._globalMapData.getValue()) {
      this.spinner.show('gds-interactive-map-global');
      await this.tcmService.requestContentById(this.gdsMapConfig.global_content_id).then(content => {
        this.parseGlobalMapComponent(content);
        const data = get(content, '0.data', null);
        if (data) {
          this.setDigitalData(data);
        }
      }).catch(e => console.warn(e.message)).finally(() => {
        this.spinner.hide('gds-interactive-map-global');
      });
    }
  }
  parseGlobalMapComponent(content) {
    const data = Array.isArray(content) ? content[0] : content;
    if (data) {
      let errorDetail = get(data, 'errorDetail[0]', null);
      const errorContent = get(errorDetail, 'noMatchContent[0]', null);
      const errorImage = get(errorDetail, 'noMatchImage', null);
      let noMatchDetail = get(data, 'noMatchDetail[0]', null);
      const noMatchContent = get(noMatchDetail, 'noMatchContent[0]', null);
      const noMatchImage = get(noMatchDetail, 'noMatchImage', null);
      let sidebar = get(data, 'sidebar[0]', null);
      if (noMatchDetail) {
        noMatchDetail = {
          noMatchContent: noMatchContent ? this.gdsDataModelService.parseContent(noMatchContent) : null,
          noMatchImage: noMatchImage ? this.gdsDataModelService.parseContent({
            image: noMatchImage
          }).image : null
        };
      }
      if (errorDetail) {
        errorDetail = {
          noMatchContent: errorContent ? this.gdsDataModelService.parseContent(errorContent) : null,
          noMatchImage: errorImage ? this.gdsDataModelService.parseContent({
            image: errorImage
          }).image : null
        };
      }
      if (sidebar) {
        sidebar = {
          applyButton: this.gdsDataModelService.parseContent({
            button: sidebar.applyButton
          }).button,
          clearButton: this.gdsDataModelService.parseContent({
            button: sidebar.clearButton
          }).button
        };
      }
      const parsedData = {
        ...data,
        errorDetail,
        noMatchDetail,
        sidebar
      };
      this._globalMapData.next(parsedData);
    }
  }
  isSmallScreen() {
    return this.window.innerWidth < 500;
  }
  /**
   * The function logs DDL events if digital data is enabled.
   * @param {string} eventAction - It could be something like "click", "submit", "filter", etc.
   * @param {string} type - It could be any value that describes the event, such as "click", "submit", "load", etc.
   * @param {any} results - The `results` parameter is an array of data that represents the results.
   */
  logDdlEvents(eventAction, type, results, url) {
    if (this.appDataLayer.digitalDataEnabled) {
      const eventInfo = this.digitalData.getEventInfoInstance('Interactive Map', eventAction, type, '', new Date().toISOString(), results, url);
      const eventCategory = this.digitalData.getEventCategoryInstance(get(this.window, 'digitalData.page.category.primaryCategory', ''), get(this.window, 'digitalData.page.category.subCategory1', ''));
      const eventData = this.digitalData.getEventInstance(eventInfo, eventCategory);
      this.digitalData.fireEvent(eventData);
    }
  }
  /**
   * The function logs DDL events if digital data is enabled.
   * @param {string} eventAction - It could be something like "click", "submit", "filter", etc.
   * @param {string} type - It could be any value that describes the event, such as "click", "submit", "load", etc.
   * @param {any} results - The `results` parameter is an array of data that represents the results.
   */
  getDdlEventData(selectedMapCard) {
    const location = get(selectedMapCard, 'data.locationEyebrow.eyebrow', ' ');
    const name = get(selectedMapCard, 'data.heading', ' ');
    const type = get(selectedMapCard, 'data.pin.placeType', ' ');
    return [location, name, type].join(',');
  }
  setDigitalData(data) {
    if (!this.appDataLayer.digitalDataEnabled) return;
    const mapImage = get(data, 'heading', '');
    const mapImageVersion = get(data, 'tileVersion', '');
    this.digitalData.setMap(mapImage, mapImageVersion, 'Image', this.zoom, this.maxZoom, this.minZoom);
  }
  setFilterDigitalData(appliedFilters, mapPOIQuantity) {
    if (!this.appDataLayer.digitalDataEnabled) return;
    const defaultMapFilters = {
      mapPOICategory: '',
      mapPOITypes: '',
      mapPOIFeatures: '',
      mapPOIVenues: '',
      mapPOILands: '',
      mapPOIQuantity
    };
    const mapFilters = appliedFilters.reduce((acc, filter) => {
      const groupKey = get(filter, 'groupKey', null);
      const filterMapping = get(filter, 'filterMapping', groupKey);
      const key = get(filter, 'key', '');
      const value = `${key}`;
      if (filterMapping.includes('venues')) {
        acc.mapPOIVenues = acc.mapPOIVenues ? `${acc.mapPOIVenues},${value}` : value;
      } else if (filterMapping.includes('place_type.type')) {
        acc.mapPOITypes = acc.mapPOITypes ? `${acc.mapPOITypes},${value}` : value;
      } else if (filterMapping.includes('land_id')) {
        acc.mapPOILands = acc.mapPOILands ? `${acc.mapPOILands},${value}` : value;
      } else if (filterMapping.includes('place_type.categories')) {
        acc.mapPOICategory = acc.mapPOICategory ? `${acc.mapPOICategory},${value}` : value;
      } else {
        acc.mapPOIFeatures = acc.mapPOIFeatures ? `${acc.mapPOIFeatures},${value}` : value;
      }
      return acc;
    }, defaultMapFilters);
    this.digitalData.setMapFilters(mapFilters);
  }
  setDDLEventData(eventAction, mapCard, mapZoomLevel) {
    const urlObj = new URL(this.window.document.URL);
    urlObj.searchParams.set('mapCard', mapCard?.data?.id);
    const url = urlObj.toString();
    const results = this.getDdlEventData(mapCard);
    this.logDdlEvents(eventAction, 'Click', results, url);
    this.digitalData.setMapProperty('mapZoomLevel', mapZoomLevel);
  }
  initGlobalListeners() {
    if (this.gdsMapConfig.global_content_id) {
      fromEvent(this.window, 'OPEN_GDS_INTERACTIVE_MAP_GLOBAL').subscribe(data => {
        const href = get(data, 'detail.href', '');
        const filterListView = get(data, 'detail.filterListView', false);
        this.openModal(false, href, filterListView);
      });
    }
  }
  static {
    this.ɵfac = function GdsInteractiveMapService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GdsInteractiveMapService)(i0.ɵɵinject(WINDOW), i0.ɵɵinject(i1.Router), i0.ɵɵinject(i1$1.AppEnvironmentService), i0.ɵɵinject(i3.TcmService), i0.ɵɵinject(i4.GdsDataModelService), i0.ɵɵinject(i1.ActivatedRoute), i0.ɵɵinject(i5.AppDataLayerService), i0.ɵɵinject(i6.SpinnerService), i0.ɵɵinject(i5.DigitalDataService));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: GdsInteractiveMapService,
      factory: GdsInteractiveMapService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GdsInteractiveMapService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: undefined,
    decorators: [{
      type: Inject,
      args: [WINDOW]
    }]
  }, {
    type: i1.Router
  }, {
    type: i1$1.AppEnvironmentService
  }, {
    type: i3.TcmService
  }, {
    type: i4.GdsDataModelService
  }, {
    type: i1.ActivatedRoute
  }, {
    type: i5.AppDataLayerService
  }, {
    type: i6.SpinnerService
  }, {
    type: i5.DigitalDataService
  }], null);
})();
class GdsInteractiveMapComponent {
  constructor() {}
  ngOnInit() {}
  static {
    this.ɵfac = function GdsInteractiveMapComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GdsInteractiveMapComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: GdsInteractiveMapComponent,
      selectors: [["upr-gds-interactive-map"]],
      standalone: false,
      decls: 0,
      vars: 0,
      template: function GdsInteractiveMapComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GdsInteractiveMapComponent, [{
    type: Component,
    args: [{
      selector: 'upr-gds-interactive-map',
      template: ``,
      standalone: false
    }]
  }], () => [], null);
})();
class MapPinsService {
  constructor(appEnvSrv) {
    this.appEnvSrv = appEnvSrv;
    this.pins = new Map();
    this.displayedPOIPins = new Map();
    this.displayedLandPins = new Map();
    this.displayedHotelPins = new Map();
    this.displayedParkPins = new Map();
    this.newDisplayedPins = new Map();
    this.venuePoiCount = {};
    this.landPoiCount = {};
    this.highestZIndex = 1;
    this.setPinsVisibility = (showMarkers, hideMarkers, map, bypassCache = false) => {
      if (!bypassCache && this.prevZoomLevel === this.zoomLevel) return;
      if (this.zoomLevel === 'poi' || this.zoomLevel === 'poi-label') {
        this.togglePOIPinLabels(this.zoomLevel === 'poi');
      }
      const bounds = map?.getBounds();
      showMarkers.forEach(pinGroup => pinGroup.forEach(pin => {
        const shouldShowPin = this.hasPois(pin.content);
        if (shouldShowPin && !pin.map) {
          if (bounds?.contains(pin.position)) {
            this.newDisplayedPins.set(pin.content, true);
          }
          pin.map = map;
        } else if (!shouldShowPin) {
          pin.map = null;
        }
      }));
      hideMarkers.forEach(pinGroup => pinGroup.forEach(pin => pin.map = null));
    };
    this.togglePOIPinLabels = hideLabel => {
      this.displayedPOIPins.forEach(pin => {
        const content = pin.content;
        if (content) {
          content.hideLabel = hideLabel;
        }
      });
    };
    this.getZoomLevelPins = map => {
      const zoom = map?.getZoom() || 0;
      if (zoom <= this.mapZoomLevels?.parks) {
        return new Map([...this.displayedParkPins, ...this.displayedHotelPins]);
      } else if (zoom >= this.mapZoomLevels?.parks && zoom < this.mapZoomLevels?.poi) {
        return new Map([...this.displayedLandPins, ...this.displayedHotelPins]);
      } else {
        return new Map([...this.displayedPOIPins, ...this.displayedHotelPins]);
      }
    };
    this.appEnvSrv.addDefaultValues(GDS_INTERACTIVE_MAP_DEFAULTS, GDS_INTERACTIVE_MAP_REPLACED_DEFAULTS);
    this.gdsMapConfig = this.appEnvSrv.getEnvVariables('map');
    this.mapZoomLevels = {
      parks: parseFloat(this.gdsMapConfig.zoom.levels.parks),
      land: parseFloat(this.gdsMapConfig.zoom.levels.land),
      poi: parseFloat(this.gdsMapConfig.zoom.levels.poi),
      poi_labels: parseFloat(this.gdsMapConfig.zoom.levels.poi_labels),
      flyTo: parseFloat(this.gdsMapConfig.zoom.levels.flyTo)
    };
  }
  createMarker(mapElement, data, AdvancedMarkerElement) {
    const title = get(data, 'heading', '');
    const position = get(data, 'pin.location', null);
    const _marker = mapElement?.nativeElement?.ownerDocument.createElement('gds-map-pin');
    _marker.style.display = 'contents';
    _marker.style.height = '0';
    const content = this.customMarkerElement(data, _marker);
    const marker = new AdvancedMarkerElement({
      position,
      title,
      content
    });
    return marker;
  }
  customMarkerElement(data, marker) {
    const id = get(data, 'id', '');
    const venueId = get(data, 'pin.venueId', '');
    const landId = get(data, 'pin.landId', '');
    const title = get(data, 'heading', '');
    const oldIcon = get(data, 'pin.icon', '').toLowerCase();
    const placeType = get(data, 'pin.placeType', '').toLowerCase();
    const icon = this.getIconName(placeType, oldIcon, id);
    const themeColor = get(data, 'pin.theme') || this.getThemeColor(placeType, id, venueId, landId);
    const contentData = {
      icon,
      ariaLabel: title,
      title,
      themeColor,
      id,
      placeType
    };
    const isLand = placeType === 'land';
    const isPark = placeType === 'park';
    const isHotel = placeType === 'hotel';
    const markerType = isLand ? 'venue' : 'base';
    marker.setAttribute('type', markerType);
    marker.setAttribute('data', JSON.stringify(contentData));
    marker.setAttribute('pin-id', id);
    marker.setAttribute('disable-tab-index', 'true');
    if (isPark || isHotel) {
      marker.setAttribute('badge', 0);
    } else if (isLand) {
      marker.setAttribute('show-cluster', 'true');
      marker.setAttribute('cluster-text', 0);
    } else {
      marker.removeAttribute('badge');
      marker.removeAttribute('show-cluster');
      marker.removeAttribute('cluster-text');
    }
    return marker;
  }
  markerByZoomLevel(map, bypassCache = false) {
    const prevZoomLevel = this.zoomLevel;
    this.prevZoomLevel = prevZoomLevel;
    this.newDisplayedPins = new Map();
    const zoom = map?.getZoom() || 0;
    if (zoom <= this.mapZoomLevels?.parks) {
      this.zoomLevel = 'park';
      this.setPinsVisibility([this.displayedParkPins, this.displayedHotelPins], [this.displayedLandPins, this.displayedPOIPins], map, bypassCache);
    } else if (zoom >= this.mapZoomLevels?.parks && zoom < this.mapZoomLevels?.poi) {
      this.zoomLevel = 'land';
      this.setPinsVisibility([this.displayedLandPins, this.displayedHotelPins], [this.displayedParkPins, this.displayedPOIPins], map, bypassCache);
    } else if (zoom >= this.mapZoomLevels?.poi) {
      if (this.mapZoomLevels?.poi_labels && zoom >= this.mapZoomLevels.poi_labels) {
        this.zoomLevel = 'poi-label';
      } else {
        this.zoomLevel = 'poi';
      }
      this.setPinsVisibility([this.displayedPOIPins, this.displayedHotelPins], [this.displayedParkPins, this.displayedLandPins], map, bypassCache);
    }
    this.toggleHotelPinBadges(map);
  }
  hideMarkers() {
    this.pins.forEach((pin, key) => {
      if (!this.displayedPOIPins.has(key) && !this.displayedLandPins.has(key) && !this.displayedParkPins.has(key) && !this.displayedHotelPins.has(key)) {
        pin.map = null;
      }
    });
  }
  hasPois(marker) {
    if (marker.hasAttribute('poi-count')) {
      return marker.getAttribute('poi-count') != '0';
    } else {
      return true;
    }
  }
  getDisplayedPins() {
    return {
      park: this.displayedParkPins,
      land: this.displayedLandPins,
      hotel: this.displayedHotelPins,
      poi: this.displayedPOIPins
    };
  }
  resetDisplayedPins() {
    this.displayedPOIPins = new Map();
    this.displayedLandPins = new Map();
    this.displayedHotelPins = new Map();
    this.displayedParkPins = new Map();
  }
  setDisplayedPin(placeType, cacheKey, pin) {
    const pinMaps = {
      park: this.displayedParkPins,
      land: this.displayedLandPins,
      hotel: this.displayedHotelPins,
      poi: this.displayedPOIPins
    };
    const selectedPinMap = pinMaps[placeType] || this.displayedPOIPins;
    selectedPinMap.set(cacheKey, pin);
  }
  isDisplayedPin(pinMaps, placeType, cacheKey) {
    const selectedPinMap = pinMaps[placeType] || this.displayedPOIPins;
    return selectedPinMap.has(cacheKey);
  }
  addPoiCount(pinData) {
    const venueId = get(pinData, 'venueId', '');
    const landId = get(pinData, 'landId', '');
    if (venueId) {
      this.venuePoiCount[venueId] = this.venuePoiCount[venueId] ? this.venuePoiCount[venueId] + 1 : 1;
    }
    if (landId) {
      this.landPoiCount[landId] = this.landPoiCount[landId] ? this.landPoiCount[landId] + 1 : 1;
    }
  }
  resetPoiCount() {
    this.venuePoiCount = {};
    this.landPoiCount = {};
  }
  updateClusterPinCounts() {
    let isNewClusterDisplayed = false;
    new Map([...this.displayedParkPins, ...this.displayedHotelPins]).forEach((pin, id) => {
      const content = pin?.content;
      if (content) {
        const prevCount = content.getAttribute('poi-count') || '0';
        const count = this.venuePoiCount[id]?.toString() || '0';
        if (content.hasAttribute('badge')) {
          content.setAttribute('badge', count);
        }
        content.setAttribute('poi-count', count);
        if (prevCount != count && prevCount === '0') {
          isNewClusterDisplayed = true;
        }
      }
    });
    this.displayedLandPins.forEach((pin, id) => {
      const content = pin?.content;
      if (content) {
        const prevCount = content.getAttribute('poi-count') || '0';
        const count = this.landPoiCount[id]?.toString() || '0';
        content.setAttribute('cluster-text', count);
        content.setAttribute('poi-count', count);
        if (prevCount != count && prevCount === '0') {
          isNewClusterDisplayed = true;
        }
      }
    });
    return isNewClusterDisplayed;
  }
  toggleHotelPinBadges(map) {
    if (this.prevZoomLevel === this.zoomLevel) return;
    const zoom = map?.getZoom() || 0;
    if (zoom >= this.mapZoomLevels?.poi) {
      this.displayedHotelPins.forEach(pin => {
        const content = pin.content;
        content.removeAttribute('badge');
      });
    } else {
      this.displayedHotelPins.forEach(pin => {
        const content = pin.content;
        const count = content.getAttribute('poi-count');
        content.setAttribute('badge', count?.toString() || '0');
      });
    }
  }
  toggleMapPin(map, id, isSelected) {
    const pins = this.getZoomLevelPins(map);
    const gdsMapPin = pins.get(id);
    if (gdsMapPin) {
      gdsMapPin.zIndex = this.highestZIndex++;
      gdsMapPin.content.isSelected = isSelected;
    }
  }
  hoverMapPin(map, id) {
    const pins = this.getZoomLevelPins(map);
    const gdsMapPin = pins.get(id);
    if (gdsMapPin) {
      gdsMapPin.zIndex = this.highestZIndex++;
    }
  }
  getIconName(placeType, category, placeId) {
    switch (placeType.toLowerCase()) {
      case 'park':
        return this.getParkIconName(placeId);
      case 'land':
        return '';
      case 'ride':
        return this.getRideIconName(category);
      case 'dining':
        return this.getDiningIconName(category);
      case 'hotel':
        return 'hotels';
      case 'show':
        return this.getShowIconName(category);
      case 'entertainment':
        return 'entertainment-filled';
      case 'shop':
        return 'shopping-filled';
      case 'events':
        return 'calendar';
      default:
        return '';
    }
  }
  getThemeColor(placeType, id, venueId, landId) {
    switch (placeType) {
      case 'resort':
      case 'park':
        return '';
      case 'land':
      case 'hotel':
        return id;
      default:
        return landId || venueId;
    }
  }
  getParkIconName(category) {
    switch (category.toLowerCase()) {
      case 'uor.ioa':
        return 'logo_IOA_la_k';
      case 'uor.usf':
        return 'logo_USF_la_k';
      case 'uor.vb':
        return 'logo_VB_stack_1c_k';
      case 'usj':
      case 'usj.usj':
        return 'park-usj';
      case 'ush':
      case 'ush.ush':
      case 'ush.lower_lot':
      case 'ush.upper_lot':
        return 'park-ush';
      case 'cw':
      case 'uor.cw':
      case 'ush.cw':
      case 'usj.cw':
        return 'park-cw';
      case 'uor.eu':
        return 'logo-ueu';
      default:
        return '';
    }
  }
  // move to new file
  getRideIconName(category) {
    switch (category.toLowerCase()) {
      case '3d-4d-experience':
        return '3d-4d';
      case 'kid-friendly':
        return 'ride-kids';
      case 'thrill':
        return 'ride-filled';
      case 'water-ride':
        return 'ride-water';
      default:
        return 'ride-filled';
    }
  }
  getDiningIconName(category) {
    switch (category.toLowerCase()) {
      case 'quick-service':
        return 'dinning-quick-serve';
      case 'character-dining':
        return 'dining-character';
      case 'fine-dining':
        return 'dining-fine';
      case 'snacks-beverages':
        return 'snacks-beverages';
      case 'causal-dining':
        return 'dining-casual';
      default:
        return 'dining-casual';
    }
  }
  getShowIconName(category) {
    switch (category.toLowerCase()) {
      case 'action':
        return 'show-action';
      case 'character':
        return 'character-encounter-v2';
      case 'comedy':
        return 'show-comedy';
      case 'entertainment':
        return 'entertainment-filled';
      case 'music':
        return 'music';
      case 'parade':
        return 'show-parade-v2';
      default:
        return 'show-comedy';
    }
  }
  static {
    this.ɵfac = function MapPinsService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MapPinsService)(i0.ɵɵinject(i1$1.AppEnvironmentService));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: MapPinsService,
      factory: MapPinsService.ɵfac
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MapPinsService, [{
    type: Injectable
  }], () => [{
    type: i1$1.AppEnvironmentService
  }], null);
})();

// <reference types="@types/google.maps" />
class MapTilesService {
  constructor(gdsMapService) {
    this.gdsMapService = gdsMapService;
    this.mapTypes = [];
    this.tileRange = this.gdsMapService.tileRange;
    this.minZoom = this.gdsMapService.minZoom;
    this.maxZoom = this.gdsMapService.maxZoom;
  }
  async createMapType(opts = {}) {
    opts.size = +opts.size || 512;
    if (this.mapTypes[opts.name]) {
      return this.mapTypes[opts.name];
    }
    const {
      Size
    } = await google.maps.importLibrary('core');
    this.mapTypes[opts.name] = new google.maps.ImageMapType({
      getTileUrl: (coord, zoom) => this.getTileUrl(coord, zoom, opts),
      tileSize: new Size(opts.size, opts.size),
      maxZoom: get(opts, 'maxZoom') || this.gdsMapService.maxZoom,
      minZoom: get(opts, 'minZoom') || this.gdsMapService.minZoom,
      name: opts.name
    });
    return this.mapTypes[opts.name];
  }
  getTileUrl(coord, zoom, opts) {
    zoom--;
    const coordinate = this.getNormalizedCoord(coord, zoom);
    if (!coordinate) {
      return '';
    }
    return [this.gdsMapService.tilesUrl, opts.version, opts.size, zoom, coordinate.x, coordinate.y].join('/');
  }
  // Normalizes the coords that tiles repeat across the x axis (horizontally)
  // like the standard Google map tiles.
  getNormalizedCoord(coord, zoom) {
    const y = coord.y;
    let x = coord.x;
    // tile range in one direction range is dependent on zoom level
    // 0 = 1 tile, 1 = 2 tiles, 2 = 4 tiles, 3 = 8 tiles, etc
    // eslint-disable-next-line no-bitwise
    const tileRange = 1 << zoom;
    // don't repeat across y-axis (vertically)
    if (y < 0 || y >= tileRange) {
      return null;
    }
    // repeat across x-axis
    if (x < 0 || x >= tileRange) {
      x = (x % tileRange + tileRange) % tileRange;
    }
    return {
      x,
      y
    };
  }
  static {
    this.ɵfac = function MapTilesService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MapTilesService)(i0.ɵɵinject(GdsInteractiveMapService));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: MapTilesService,
      factory: MapTilesService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MapTilesService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: GdsInteractiveMapService
  }], null);
})();
let GoogleMapComponent = class GoogleMapComponent {
  constructor(apiKey, document, window, filterService, filterListService, gdsButtonEventsService, pageLabelsService, mapPinsService, mapTiles, gdsMapService, route, utilities) {
    this.apiKey = apiKey;
    this.document = document;
    this.window = window;
    this.filterService = filterService;
    this.filterListService = filterListService;
    this.gdsButtonEventsService = gdsButtonEventsService;
    this.pageLabelsService = pageLabelsService;
    this.mapPinsService = mapPinsService;
    this.mapTiles = mapTiles;
    this.gdsMapService = gdsMapService;
    this.route = route;
    this.utilities = utilities;
    this.isMapCardContainerLoaded = false;
    this.isNavigateToCardCompleted = false;
    this.cardsExist = false;
    this.loadingInitialCards = true;
    this.subscriptions = new Subscription();
    this.PIN_VERTICAL_PADDING = 6;
    this.PIN_HORIZONTAL_PADDING = 8;
    this.PIN_LABEL_HORIZONTAL_PADDING = 15;
    this.debounceUpdateMapCards = debounce(() => {
      this.updateMapCards();
    }, 100);
  }
  ngOnInit() {
    if (!this.pageView) {
      this.filterService.setFilterParamName('gmapFilters');
    }
  }
  ngAfterViewInit() {
    this.pageLabelsService.get().then(data => {
      this.pageLabels = data;
    });
    this.subscriptions.add(fromEvent(this.mapElement.nativeElement, 'gdsMapContainerLoaded').subscribe(() => {
      this.document.getElementById('google-maps-jssdk') && this.window.google ? this.init() : this.loadSdk();
    }));
    this.subscriptions.add(fromEvent(this.mapElement.nativeElement, 'mapModalToggled').subscribe(() => {
      this.gdsMapService.mapModalToggled(!this.modalOpen, this.pageView);
      if (this.modalOpen) {
        this.unselectMapCard(true);
      } else {
        this.updateMapCards();
      }
      if (this.modalOpen) {
        this.filterListService.applyDefaultView();
      }
    }));
    this.subscriptions.add(fromEvent(this.mapElement.nativeElement, 'mapCardClicked').subscribe(event => {
      const selectedCard = event.target;
      this.selectMapCard(selectedCard, true, 400, 'POI Card');
    }));
    this.subscriptions.add(fromEvent(this.mapElement.nativeElement, 'mobileMapLaunched').subscribe(() => {
      const tilesLoaded$ = fromEventPattern(handler => this.map?.addListener('tilesloaded', handler), (_, listener) => google.maps.event.removeListener(listener));
      tilesLoaded$.pipe(take(1)).subscribe(() => {
        this.loadingInitialCards = true;
        this.flyToBounds(this.pinBounds, true, 500);
        this.loadingInitialCards = false;
      });
      this.gdsMapService.openModal(this.pageView);
    }));
    this.subscriptions.add(fromEvent(this.mapElement.nativeElement, 'gdsMapPinConnected').subscribe(() => {
      this.mapPinConnected();
    }));
    this.subscriptions.add(fromEvent(this.mapElement.nativeElement, 'loadMoreCards').subscribe(() => {
      this.cardsToDisplay += this.noOfCards;
      this.updateMapCards(false);
    }));
    this.subscriptions.add(fromEvent(this.mapElement.nativeElement, 'buttonClicked').subscribe(e => this.gdsButtonEventsService.buttonClickHandler(e)));
    this.registerZoomControlsEvents();
  }
  selectMapCard(card, willUpdateQueryParams = true, flyToDuration = 400, ddlEvent) {
    this.cardsToDisplay = this.noOfCards;
    if (this.selectedMapCard) {
      this.selectedMapCard.selected = false;
      this.mapPinsService.toggleMapPin(this.map, this.selectedMapCard.id, false);
    }
    this.selectedMapCard = card;
    if (this.selectedMapCard) {
      this.selectedMapCard.selected = true;
    } else if (!this.cardsExist && !willUpdateQueryParams) {
      return;
    }
    const latLng = card?.data?.pin?.location;
    const mapCardContainer = this.mapElement.nativeElement.querySelector('gds-map-card-interactive-container');
    mapCardContainer?.selectCard(this.selectedMapCard?.getBoundingClientRect().height || 60);
    if (ddlEvent && this.selectedMapCard) {
      this.gdsMapService.setDDLEventData(ddlEvent, this.selectedMapCard, (this.map?.getZoom() || this.zoom).toString());
    }
    if (latLng) {
      const placeType = get(this.selectedMapCard, 'data.pin.placeType', '').toLowerCase();
      const currZoom = this.map?.getZoom() || 0;
      let zoom = this.zoomLevels?.flyTo;
      if (placeType === 'park') {
        zoom = this.zoomLevels?.land;
      } else if (placeType === 'land' || placeType === 'hotel' && currZoom < this.zoomLevels?.poi) {
        flyToDuration = 750;
        zoom = this.zoomLevels?.poi_labels;
      } else if (this.selectedMapCard) {
        this.mapPinsService.toggleMapPin(this.map, this.selectedMapCard.id, true);
      }
      const {
        offsetLatLng
      } = this.getOffsetLatLng(latLng, zoom);
      this.flyTo(offsetLatLng, zoom, flyToDuration);
    }
    if (willUpdateQueryParams) {
      if (this.queryParamTimeout) {
        clearTimeout(this.queryParamTimeout);
      }
      this.queryParamTimeout = setTimeout(() => {
        this.gdsMapService.appendMapCardIdToQueryParams(card?.data?.id);
      }, flyToDuration + 200);
    }
  }
  unselectMapCard(willUpdateQueryParams) {
    this.selectMapCard(null, willUpdateQueryParams);
  }
  loadSdk() {
    this.apiKey = this.gdsMapService.apiKey;
    const script = this.document.createElement('script');
    script.id = 'google-maps-jssdk';
    script.type = 'text/javascript';
    script.async = true;
    script.defer = true;
    script.text = `
        (g => {
          var h, a, k, p = "The Google Maps JavaScript API", c = "google", l = "importLibrary", q = "__ib__", m = document, b = window;
          b = b[c] || (b[c] = {});
          var d = b.maps || (b.maps = {}),
            r = new Set,
            e = new URLSearchParams,
            u = () => h || (h = new Promise(async (f, n) => {
              await (a = m.createElement("script"));
              e.set("libraries", [...r] + "");
              for (k in g) e.set(k.replace(/[A-Z]/g, t => "_" + t[0].toLowerCase()), g[k]);
              e.set("callback", c + ".maps." + q);
              a.src = \`https://maps.\${c}apis.com/maps/api/js?\${e}\`;
              d[q] = f;
              a.onerror = () => h = n(Error(p + " could not load."));
              a.nonce = m.querySelector("script[nonce]")?.nonce || "";
              m.head.append(a);
            }));
          d[l] ? console.warn(p + " only loads once. Ignoring:", g) : d[l] = (f, ...n) => r.add(f) && u().then(() => d[l](f, ...n));
        })({
          key: "${this.apiKey}",
          v: "weekly",
          // Use the 'v' parameter to indicate the version to use (weekly, beta, alpha, etc.).
          // Add other bootstrap parameters as needed, using camel case.
        });
      `;
    this.document.body.appendChild(script);
    this.init();
  }
  async init() {
    this.filterService.processFilters(this.mapElement.nativeElement);
    this.setMapDefaults();
    await this.createMap();
    await this.setMapType();
    this.addListeners();
  }
  async createMap() {
    const {
      Map
    } = await google.maps.importLibrary('maps');
    const gmapContainer = this.mapElement.nativeElement.querySelector('.gds-map-container-map-google');
    if (!gmapContainer) {
      return;
    }
    const flData = this.filterService.getComponentData();
    const rawBounds = get(flData, 'bounds');
    const bounds = Array.isArray(rawBounds) ? rawBounds[0] : rawBounds;
    const rawMobileRestrictedBounds = get(bounds, 'mobileMapBounds');
    this.mobileRestrictedBounds = Array.isArray(rawMobileRestrictedBounds) ? rawMobileRestrictedBounds[0] : rawMobileRestrictedBounds;
    const rawDesktopRestrictedBounds = get(bounds, 'desktopMapBounds');
    this.desktopRestrictedBounds = Array.isArray(rawDesktopRestrictedBounds) ? rawDesktopRestrictedBounds[0] : rawDesktopRestrictedBounds;
    this.updateRestrictedBounds();
    this.map = new Map(gmapContainer, {
      center: {
        lat: bounds && bounds?.latitude ? +bounds.latitude : this.gdsMapService.lat,
        lng: bounds && bounds?.longitude ? +bounds.longitude : this.gdsMapService.lng
      },
      backgroundColor: this.bgColor,
      zoom: this.zoom,
      minZoom: this.minZoom || this.gdsMapService.minZoom,
      maxZoom: this.maxZoom || this.gdsMapService.maxZoom,
      mapId: this.gdsMapService.mapId,
      streetViewControl: !!this.streetView,
      draggable: true,
      disableDefaultUI: true,
      keyboardShortcuts: true,
      heading: this.rotation,
      headingInteractionEnabled: false,
      tilt: this.tilt,
      tiltInteractionEnabled: false,
      gestureHandling: this.pageView ? 'cooperative' : 'greedy',
      restriction: {
        latLngBounds: this.bounds
      },
      mapTypeControlOptions: this.mapTypeControlOptions || {
        mapTypeIds: [this.gdsMapService.mapType]
      }
    });
    google.maps.event.trigger(this.map, 'resize');
  }
  mapLoadedWithMapCards() {
    const throttledUpdateMapCards = throttle(() => {
      if (!this.flyingToBounds) {
        this.updateMapCards();
        this.registerZoomControlsDisabledListener();
      }
    }, 500);
    google.maps.event.addListener(this.map, 'idle', throttledUpdateMapCards);
    const mapCardContainer = this.getMapCardContainer();
    if (mapCardContainer) {
      mapCardContainer.style.visibility = 'visible';
    }
  }
  async addListeners() {
    if (!this.map) {
      return;
    }
    const {
      AdvancedMarkerElement
    } = await google.maps.importLibrary('marker');
    google.maps.event.addListener(this.map, 'click', () => {
      this.unselectMapCard(true);
    });
    google.maps.event.addListener(this.map, 'dragend', () => {
      this.unselectMapCard(!!this.selectedMapCard);
    });
    google.maps.event.addListener(this.map, 'zoom_changed', () => {
      this.mapPinsService.markerByZoomLevel(this.map);
      if (this.selectedMapCard && !this.flyingToBounds || this.cardsToDisplay !== this.noOfCards) {
        this.unselectMapCard(true);
      }
    });
    google.maps.event.addListener(this.map, 'tilesloaded', () => {
      if (!this.isNavigateToCardCompleted) {
        this.navigateToCard();
      }
    });
    google.maps.event.addListenerOnce(this.map, 'idle', () => {
      this.subscriptions.add(this.filterService.getMapCards$.subscribe(results => {
        this.loadMapCards(results, AdvancedMarkerElement);
        this.gdsMapService.setFilterDigitalData(this.filterService.appliedFilters, results.mapCards?.length ?? 0);
      }));
    });
  }
  loadMapCards(resp, AdvancedMarkerElement) {
    const {
      mapCards,
      newAppliedFilters
    } = resp;
    if (this.loadingInitialCards && this.map) {
      this.mapLoadedWithMapCards();
    } else {
      this.unselectMapCard(true);
      this.shouldUpdateOnRender = true;
    }
    this.pinBounds = new google.maps.LatLngBounds();
    let hasPinsOutsideBounds = false;
    let hasPins = false;
    this.mapPinsService.resetDisplayedPins();
    this.mapPinsService.resetPoiCount();
    const {
      pixelOffset
    } = this.getOffsetDiff();
    if (!mapCards?.length) {
      this.mapElement.nativeElement.showEmptyCard = true;
    }
    const hasNewArea = (newAppliedFilters || []).some(f => f.filterMapping?.includes('venue_id') || f.filterMapping?.includes('land_id'));
    const queryParams = this.route.snapshot.queryParams;
    const selectedCardId = queryParams.mapCard;
    let selectedMapCardExists = false;
    const isMobile = this.isMobile();
    const unrotatedBounds = this.getUnrotatedBounds();
    mapCards.forEach(card => {
      const pin = card.pin;
      const location = get(pin, 'location', null);
      const placeType = get(pin, 'placeType', '').toLowerCase();
      const isCluster = ['land', 'park', 'hotel'].includes(placeType);
      if (location && location.lat && location.lng) {
        const cacheKey = card.id ?? `${location.lat},${location.lng}`;
        const cachedPin = this.mapPinsService.pins.get(cacheKey);
        hasPins = true;
        if (card.id === selectedCardId) {
          selectedMapCardExists = true;
        }
        if (!isCluster && !this.isPositionWithinBounds({
          lat: location.lat,
          lng: location.lng
        }, unrotatedBounds, pixelOffset, isMobile)) {
          hasPinsOutsideBounds = true;
        }
        if (cachedPin && cachedPin.position) {
          this.mapPinsService.setDisplayedPin(placeType, cacheKey, cachedPin);
          if (!isCluster) {
            this.pinBounds.extend(cachedPin.position);
            this.mapPinsService.addPoiCount(pin);
          }
          return;
        }
        const marker = this.mapPinsService.createMarker(this.mapElement, card, AdvancedMarkerElement);
        this.markerClickHandler(marker);
        this.markerHoverHandler(marker);
        if (marker.position && !isCluster) {
          this.pinBounds.extend(marker.position);
          this.mapPinsService.addPoiCount(pin);
        }
        this.mapPinsService.setDisplayedPin(placeType, cacheKey, marker);
        this.mapPinsService.pins.set(cacheKey, marker);
      }
    });
    this.mapPinsService.hideMarkers();
    this.mapPinsService.updateClusterPinCounts();
    if (this.loadingInitialCards) {
      if (selectedMapCardExists) {
        this.loadingInitialCards = false;
        return;
      }
      this.flyToBounds(this.pinBounds, true, 1500);
      this.loadingInitialCards = false;
    } else if (hasNewArea) {
      this.flyToBounds(this.pinBounds, true, 1500);
    } else if (hasPins && !hasPinsOutsideBounds && newAppliedFilters.length > 0) {
      this.flyToBounds(this.pinBounds, false, 1500);
    } else if (!this.shouldUpdateOnRender || this.mapPinsService.newDisplayedPins.size === 0) {
      this.updateMapCards();
    }
    this.mapPinsService.markerByZoomLevel(this.map, true);
  }
  markerClickHandler(marker) {
    google.maps.event.addListener(marker, 'click', () => {
      const markerEl = marker.content;
      const pinId = markerEl.getAttribute('pin-id');
      const cardContainer = this.getMapCardContainer();
      const mapCard = cardContainer?.querySelector(`[id="${pinId}"]`);
      if (mapCard) {
        this.selectMapCard(mapCard, true, 400, 'POI Pin');
      }
    });
  }
  markerHoverHandler(marker) {
    marker.content.addEventListener('mouseenter', () => {
      const markerEl = marker.content;
      const pinId = markerEl.getAttribute('pin-id');
      if (pinId) {
        this.mapPinsService.hoverMapPin(this.map, pinId);
      }
    });
  }
  async setMapType() {
    if (this.mapType !== this.gdsMapService.mapType) {
      return;
    }
    const uoMapType = await this.mapTiles.createMapType({
      name: this.mapType,
      version: this.tileVersion,
      minZoom: this.minZoom,
      maxZoom: this.maxZoom
    });
    if (!uoMapType) {
      return;
    }
    if (this.map) {
      if (this.map.mapTypes) {
        this.map.mapTypes.set(this.gdsMapService.mapType, uoMapType);
      }
      this.map.setMapTypeId(this.gdsMapService.mapType);
      this.map.overlayMapTypes.push(uoMapType);
    }
  }
  setMapDefaults() {
    const flData = this.filterService.getComponentData();
    const maxZoom = get(flData, 'maxZoomLevel', 0);
    const minZoom = get(flData, 'minZoomLevel', 0);
    const rotation = get(flData, 'rotation', -90);
    const tilt = get(flData, 'tilt', 45);
    const noOfCards = get(flData, 'noOfCards', 9);
    const tileVersion = get(flData, 'tileVersion');
    const backgroundColor = get(flData, 'backgroundColor', '#A8BE6C');
    const rawBounds = get(flData, 'bounds');
    const bounds = Array.isArray(rawBounds) ? rawBounds[0] : rawBounds;
    const rawZoomLevels = get(bounds, 'zoomLevel');
    const zoomLevel = Array.isArray(rawZoomLevels) ? rawZoomLevels[0] : rawZoomLevels;
    this.maxZoom = Array.isArray(maxZoom) ? parseFloat(maxZoom[0]) : parseFloat(maxZoom);
    this.minZoom = Array.isArray(minZoom) ? parseFloat(minZoom[0]) : parseFloat(minZoom);
    if (this.gdsMapService.isSmallScreen()) {
      this.minZoom--;
      this.zoom--;
    }
    this.noOfCards = this.isMobile() ? 100 : Array.isArray(noOfCards) ? parseFloat(noOfCards[0]) : parseFloat(noOfCards);
    this.rotation = Array.isArray(rotation) ? parseFloat(rotation[0]) : parseFloat(rotation);
    this.tilt = Array.isArray(tilt) ? parseFloat(tilt[0]) : parseFloat(tilt);
    this.tileVersion = tileVersion;
    this.bgColor = backgroundColor;
    this.mapPinsService.mapZoomLevels = zoomLevel ? mapValues(zoomLevel, num => Array.isArray(num) ? +num[0] : +num) : this.mapPinsService.mapZoomLevels;
    this.zoomLevels = this.mapPinsService.mapZoomLevels;
  }
  flyTo(center, zoom = this.zoomLevels?.flyTo, duration = 300) {
    if (!this.map || !center || !center.lat || !center.lng) return;
    const startLatLng = {
      lat: this.map.getCenter()?.lat() || 0,
      lng: this.map.getCenter()?.lng() || 0,
      zoom: this.map?.getZoom() || 0
    };
    const targetLatLng = {
      lat: center.lat(),
      lng: center.lng(),
      zoom
    };
    const cameraOptions = {
      zoom,
      center: new google.maps.LatLng(startLatLng.lat, startLatLng.lng)
    };
    const tween = new Tween(startLatLng).to(targetLatLng, duration).easing(Easing.Quadratic.Out).onUpdate(() => {
      cameraOptions.center = new google.maps.LatLng(startLatLng.lat || 0, startLatLng.lng);
      cameraOptions.zoom = startLatLng.zoom;
      this.map?.moveCamera(cameraOptions);
    }).onComplete(() => {
      this.flyingToBounds = false;
    });
    this.flyingToBounds = true;
    tween.start();
    function animate(time) {
      requestAnimationFrame(animate);
      update(time);
    }
    requestAnimationFrame(animate);
  }
  flyToBounds(bounds, allowZoomOut = false, duration = 600) {
    const mapBounds = this.map?.getBounds();
    if (!this.map || !mapBounds || !bounds || bounds.isEmpty()) return this.updateMapCards();
    const heading = this.rotation;
    const tilt = this.tilt;
    const startCenter = this.map.getCenter();
    const startZoom = this.map.getZoom();
    // Calculate targeted zoom and center.
    this.map?.setOptions({
      restriction: null
    });
    this.map.fitBounds(bounds, 100);
    this.map.setHeading(heading);
    this.map.setTilt(tilt);
    const targetCenter = this.map.getCenter();
    let targetZoom = this.map.getZoom() || startZoom;
    if (this.gdsMapService.isSmallScreen()) {
      targetZoom = this.loadingInitialCards ? this.minZoom : targetZoom - 1;
    } else if (this.loadingInitialCards && targetZoom > this.zoomLevels?.parks) {
      targetZoom = this.zoomLevels?.parks;
    }
    const {
      offsetLatLng: offsetTarget
    } = this.getOffsetLatLng(targetCenter, targetZoom);
    // Reset map to original state
    this.map.setCenter(startCenter);
    this.map.setZoom(startZoom);
    this.map.setHeading(heading);
    this.map.setTilt(tilt);
    if (!allowZoomOut && targetZoom < startZoom) {
      return this.updateMapCards();
    }
    const startLatLng = {
      lat: startCenter?.lat() || 0,
      lng: startCenter?.lng() || 0,
      zoom: startZoom || 0
    };
    const targetLatLng = {
      lat: offsetTarget?.lat() || 0,
      lng: offsetTarget?.lng() || 0,
      zoom: targetZoom || 0
    };
    const cameraOptions = {
      zoom: startZoom,
      center: new google.maps.LatLng(startLatLng.lat, startLatLng.lng)
    };
    const tween = new Tween(startLatLng).to(targetLatLng, duration).easing(Easing.Quadratic.Out).onUpdate(state => {
      cameraOptions.center = new google.maps.LatLng(state.lat, state.lng);
      cameraOptions.zoom = state.zoom;
      this.map?.moveCamera(cameraOptions);
    }).onComplete(() => {
      this.flyingToBounds = false;
      this.updateMapCards();
      this.mapPinsService.markerByZoomLevel(this.map);
      this.map?.setOptions({
        restriction: {
          latLngBounds: this.bounds
        }
      });
    });
    this.flyingToBounds = true;
    tween.start();
    function animate(time) {
      requestAnimationFrame(animate);
      update(time);
    }
    requestAnimationFrame(animate);
  }
  getOffsetLatLng(latLng, zoom = this.zoomLevels?.flyTo, inverse = false, middleOffset = true) {
    const projection = this.map?.getProjection();
    if (!projection || !latLng) return {};
    const mapCardContainer = this.getMapCardContainer();
    const originalPoint = projection?.fromLatLngToPoint(latLng);
    if (!originalPoint || !zoom || !mapCardContainer) return {
      offsetLatLng: latLng
    };
    const angleRad = (this.map?.getHeading() || 0) * (Math.PI / 180);
    const scale = Math.pow(2, zoom);
    let offset = 0;
    let offsetX = 0;
    let offsetY = 0;
    if (this.isMobile()) {
      if (this.loadingInitialCards) {
        offset = mapCardContainer.getBoundingClientRect().height || 0;
      } else {
        offset = this.selectedMapCard ? this.selectedMapCard.getBoundingClientRect().height : 0;
      }
      offset = middleOffset ? offset / 2 : offset;
      offsetX = offset * Math.sin(angleRad);
      offsetY = -offset * Math.cos(angleRad);
    } else {
      offset = mapCardContainer.getBoundingClientRect().width;
      offset = middleOffset ? offset / 2 : offset;
      offsetX = offset * Math.cos(angleRad);
      offsetY = offset * Math.sin(angleRad);
    }
    const pixelOffset = new google.maps.Point(offsetX / scale || 0, offsetY / scale || 0);
    const inverseOffset = inverse ? -1 : 1;
    pixelOffset.x *= inverseOffset;
    pixelOffset.y *= inverseOffset;
    const offsetPoint = new google.maps.Point(originalPoint?.x - pixelOffset.x, originalPoint?.y - pixelOffset.y);
    const offsetLatLng = projection.fromPointToLatLng(offsetPoint);
    return {
      offsetLatLng,
      pixelOffset
    };
  }
  getOffsetCenter() {
    return this.getOffsetLatLng(this.map?.getCenter(), this.map?.getZoom(), true, true);
  }
  getOffsetDiff() {
    const {
      offsetLatLng,
      pixelOffset
    } = this.getOffsetCenter();
    const offsetCenter = offsetLatLng?.toJSON();
    const mapCenter = this.map?.getCenter()?.toJSON();
    if (!offsetCenter || !mapCenter) return {
      center: undefined,
      offsets: {
        lat: 0,
        lng: 0
      },
      pixelOffset
    };
    const centerLat = offsetCenter.lat;
    const centerLng = offsetCenter.lng;
    const latOffset = mapCenter.lat ? centerLat - mapCenter.lat : 0;
    const lngOffset = mapCenter.lng ? mapCenter.lng - centerLng : 0;
    return {
      center: offsetCenter,
      offsets: {
        lat: latOffset,
        lng: lngOffset
      },
      pixelOffset
    };
  }
  getOppositeAngle() {
    return -(this.map?.getHeading() || 0) * (Math.PI / 180);
  }
  getUnrotatedBounds() {
    if (!this.map) return;
    const bounds = this.map.getBounds();
    const projection = this.map.getProjection();
    if (!bounds || !projection) return;
    const sw = bounds.getSouthWest();
    const ne = bounds.getNorthEast();
    const swPoint = projection.fromLatLngToPoint(sw);
    const nePoint = projection.fromLatLngToPoint(ne);
    if (!swPoint || !nePoint) return;
    const targetAngle = this.getOppositeAngle();
    return {
      swPoint: this.getRotatedPoint(swPoint, targetAngle),
      nePoint: this.getRotatedPoint(nePoint, targetAngle)
    };
  }
  isMarkerElWithinBounds(pinRect, cardsRect, mapRect, isMobile) {
    if (!mapRect || !pinRect) return false;
    const horizontalPadding = this.mapPinsService.zoomLevel === 'poi' ? this.PIN_HORIZONTAL_PADDING : this.PIN_LABEL_HORIZONTAL_PADDING;
    const isWithinView = pinRect.bottom - this.PIN_VERTICAL_PADDING > mapRect.top && pinRect.top - this.PIN_VERTICAL_PADDING < mapRect.bottom && pinRect.right - horizontalPadding > mapRect.left && pinRect.left + horizontalPadding < mapRect.right;
    if (!isWithinView) return false;
    // Check if pin is behind overlay
    if (!isMobile) {
      return pinRect.right - horizontalPadding > cardsRect.right;
    }
    return true;
  }
  isPositionWithinBounds(position, bounds, offset, isMobile) {
    const projection = this.map?.getProjection();
    if (!this.map || !projection || !bounds) return false;
    const targetAngle = this.getOppositeAngle();
    const pinPoint = projection.fromLatLngToPoint(position);
    if (!pinPoint) return false;
    const unrotatedPin = this.getRotatedPoint(pinPoint, targetAngle);
    const {
      swPoint,
      nePoint
    } = bounds;
    const inverseLat = swPoint.x > nePoint.x;
    let minLat = inverseLat ? nePoint.x : swPoint.x;
    const maxLat = inverseLat ? swPoint.x : nePoint.x;
    const inverseLng = swPoint.y > nePoint.y;
    let minLng = inverseLng ? nePoint.y : swPoint.y;
    const maxLng = inverseLng ? swPoint.y : nePoint.y;
    if (!isMobile && offset) {
      minLat -= offset.x * 2;
      minLng += offset.y * 2;
    }
    const latInBounds = unrotatedPin.x >= minLat && unrotatedPin.x <= maxLat;
    const lngInBounds = unrotatedPin.y >= minLng && unrotatedPin.y <= maxLng;
    return latInBounds && lngInBounds;
  }
  updateMapCards(resetCardCount = true) {
    const container = this.getMapCardContainer();
    const {
      center
    } = this.getOffsetDiff();
    if (!container || !center || !this.map) return;
    if (resetCardCount) {
      this.cardsToDisplay = this.noOfCards;
    }
    const centerLat = center.lat;
    const centerLng = center.lng;
    const cards = Array.from(container.querySelectorAll('gds-map-card-interactive'));
    const _displayedPins = this.mapPinsService.getZoomLevelPins(this.map);
    this.cardsExist = false;
    const isMobile = this.isMobile();
    const mapRect = this.mapElement.nativeElement.querySelector('.gds-map-container-map-google')?.getBoundingClientRect();
    const visibleCards = [];
    cards.forEach(el => {
      const data = this.utilities.getComponentData(el);
      const id = get(data, 'id', el.id);
      const pin = _displayedPins.get(id);
      if (!pin || !pin.position) {
        el.style.display = 'none';
        el.style.order = 'unset';
        return;
      }
      const pinLat = pin.position.lat;
      const pinLng = pin.position.lng;
      const distanceSquared = (pinLat - centerLat) ** 2 + (pinLng - centerLng) ** 2;
      const isVisible = pin.map && this.isMarkerElWithinBounds(pin.content?.parentElement?.getBoundingClientRect(), container.getBoundingClientRect(), mapRect, isMobile);
      const hasPois = this.mapPinsService.hasPois(pin.content);
      if (!isVisible || !hasPois) {
        el.style.display = 'none';
        el.style.order = 'unset';
      }
      if (isVisible && hasPois) {
        this.cardsExist = true;
        visibleCards.push({
          el,
          distanceSquared
        });
      }
    });
    const sortedVisibleCards = visibleCards.sort((a, b) => a.distanceSquared - b.distanceSquared);
    sortedVisibleCards.forEach((item, index) => {
      item.el.style.display = index < this.cardsToDisplay ? 'block' : 'none';
      item.el.style.order = index.toString();
      const button = item.el.querySelector('button');
      if (button) {
        button.tabIndex = index === 0 ? 0 : -1;
      }
    });
    this.mapElement.nativeElement.showLoadingCard = sortedVisibleCards.length > this.cardsToDisplay;
    this.mapElement.nativeElement.showEmptyCard = !this.cardsExist;
  }
  navigateToCard() {
    if (this.isNavigateToCardCompleted) return;
    const queryParams = this.route.snapshot.queryParams;
    const cardId = queryParams.mapCard;
    if (!cardId) {
      this.isNavigateToCardCompleted = true;
      return;
    }
    const mapContainer = this.getMapCardContainer();
    const mapCard = mapContainer?.querySelector(`[id="${cardId}"]`);
    if (mapCard) {
      this.updateMapCards();
      this.selectMapCard(mapCard, false, 1500);
      setTimeout(() => {
        this.selectMapCard(mapCard, false, 0);
      }, 1800);
      this.isNavigateToCardCompleted = true;
    }
  }
  registerZoomControlsEvents() {
    const zoomControlsSelectedEvent = fromEvent(this.mapElement?.nativeElement, 'segmentedButtonSelected');
    this.subscriptions.add(zoomControlsSelectedEvent.subscribe(event => {
      this.zoomControlsEventHandler(event);
    }));
  }
  registerZoomControlsDisabledListener() {
    if (!this.map) {
      return;
    }
    const currentZoom = this.map?.getZoom() ?? 0;
    const disableIndex = currentZoom >= this.maxZoom ? 0 : currentZoom <= this.minZoom ? 1 : -1;
    this.disableControlOnZoomEvent(disableIndex);
  }
  zoomControlsEventHandler(event) {
    if (!this.map) {
      return;
    }
    const mapInstance = this.map;
    const index = event instanceof CustomEvent ? event?.detail?.index : event;
    const increase = index === 0;
    const decrease = index === 1;
    const mapZoom = mapInstance?.getZoom() || 0;
    let currentZoom = increase ? Math.floor(mapZoom) : Math.ceil(mapZoom);
    increase && currentZoom <= this.maxZoom && (currentZoom += 1);
    decrease && currentZoom >= this.minZoom && (currentZoom -= 1);
    const zoomWithinRange = currentZoom >= this.minZoom && currentZoom <= this.maxZoom;
    const disableIndex = currentZoom >= this.maxZoom ? 0 : currentZoom <= this.minZoom ? 1 : -1;
    if (zoomWithinRange) {
      mapInstance?.setZoom(currentZoom);
      this.centerMapPinsOnZoomControlsEvent(currentZoom);
    }
    this.disableControlOnZoomEvent(disableIndex);
  }
  centerMapPinsOnZoomControlsEvent(zoom) {
    const pins = Array.from(this.mapPinsService.displayedPOIPins.values());
    const validPins = pins?.filter(pin => {
      if (!pin || !pin.position || !this.map) {
        return false;
      }
      return this.map.getBounds()?.contains(pin.position);
    });
    if (validPins?.length === 0) {
      return;
    }
    const sumLat = validPins?.reduce((acc, pin) => acc + pin.position?.lat, 0);
    const sumLng = validPins?.reduce((acc, pin) => acc + pin.position?.lng, 0);
    const averageLat = sumLat / validPins?.length;
    const averageLng = sumLng / validPins?.length;
    const center = new google.maps.LatLng(averageLat, averageLng);
    const {
      offsetLatLng
    } = this.getOffsetLatLng(center, zoom);
    if (offsetLatLng) {
      this.map?.setCenter(offsetLatLng);
    }
  }
  disableControlOnZoomEvent(disableZoomControl) {
    const data = this.filterService.getComponentData();
    if (!data) return;
    const zoomControlsData = data.zoomControls || {
      segmentedButtons: []
    };
    const updatedSegmentedButtons = zoomControlsData.segmentedButtons?.map((button, i) => ({
      ...button,
      disabled: disableZoomControl !== -1 ? i === disableZoomControl : false
    }));
    const updatedZoomControlsData = {
      ...zoomControlsData,
      segmentedButtons: updatedSegmentedButtons
    };
    const buttonContainer = this.mapElement?.nativeElement?.querySelector('.gds-map-container--zoom-controls gds-segmented-container');
    buttonContainer?.setAttribute('data', JSON.stringify(updatedZoomControlsData));
  }
  ngOnDestroy() {
    if (!this.map) {
      return;
    }
    if (this.infoWindow) {
      google.maps.event.clearListeners(this.infoWindow, 'closeclick');
    }
    google.maps.event.clearListeners(this.map, 'click');
    google.maps.event.clearInstanceListeners(this.map);
    google.maps.event.clearInstanceListeners(this.window);
    this.map = null;
    this.mapPinsService.displayedPOIPins = new Map();
    this.mapPinsService.pins = new Map();
  }
  // Set scroll wheel zoom for full screen modal
  mapDidRender(event) {
    const gestureHandling = event?.detail ? 'greedy' : 'cooperative';
    this.updateRestrictedBounds();
    this.map?.setOptions({
      gestureHandling,
      restriction: {
        latLngBounds: this.bounds
      }
    });
    if (this.map) {
      google.maps.event.trigger(this.map, 'resize');
    }
    if (!this.isMapCardContainerLoaded) {
      const mapCardContainer = this.getMapCardContainer();
      if (mapCardContainer) {
        mapCardContainer.style.visibility = 'hidden';
      }
      this.isMapCardContainerLoaded = true;
    }
  }
  /**
   * Method ran after gds-map-pins are attached to the DOM
   */
  mapPinConnected() {
    this.debounceUpdateMapCards();
  }
  getMapCardContainer() {
    return this.mapElement.nativeElement.querySelector('.gds-map-card-interactive-container-desktop') || this.mapElement.nativeElement.querySelector('.gds-map-card-interactive-container-mobile');
  }
  isMobile() {
    return !!this.mapElement.nativeElement.querySelector('.gds-map-card-interactive-container-mobile');
  }
  getRotatedPoint(point, angle) {
    const sin = Math.sin(angle);
    const cos = Math.cos(angle);
    return new google.maps.Point(point.x * cos - point.y * sin, point.x * sin + point.y * cos);
  }
  updateRestrictedBounds() {
    this.bounds = this.mobileRestrictedBounds && this.desktopRestrictedBounds ? this.isMobile() ? mapValues(this.mobileRestrictedBounds, num => {
      return +num;
    }) : mapValues(this.desktopRestrictedBounds, num => {
      return +num;
    }) : this.gdsMapService.bounds;
  }
  static {
    this.ɵfac = function GoogleMapComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GoogleMapComponent)(i0.ɵɵdirectiveInject('GoogleMapsApiKey'), i0.ɵɵdirectiveInject(DOCUMENT), i0.ɵɵdirectiveInject(WINDOW), i0.ɵɵdirectiveInject(i1$2.GdsInteractiveMapFilterService), i0.ɵɵdirectiveInject(i1$2.GdsFilterListService), i0.ɵɵdirectiveInject(i2.GdsButtonEventsService), i0.ɵɵdirectiveInject(i3$1.PageLabelsResolver), i0.ɵɵdirectiveInject(MapPinsService), i0.ɵɵdirectiveInject(MapTilesService), i0.ɵɵdirectiveInject(GdsInteractiveMapService), i0.ɵɵdirectiveInject(i1.ActivatedRoute), i0.ɵɵdirectiveInject(i8.GdsCommonUtilityService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: GoogleMapComponent,
      selectors: [["upr-google-map"]],
      viewQuery: function GoogleMapComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c0, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.mapElement = _t.first);
        }
      },
      inputs: {
        gdsMapContainerData: "gdsMapContainerData",
        lat: "lat",
        lng: "lng",
        zoom: "zoom",
        streetView: "streetView",
        mapTypeControl: "mapTypeControl",
        mapType: "mapType",
        styles: "styles",
        mapTypeControlOptions: "mapTypeControlOptions",
        defaultTile: "defaultTile",
        pageView: "pageView",
        modalOpen: "modalOpen",
        theme: "theme"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([GdsInteractiveMapFilterService, MapPinsService])],
      decls: 2,
      vars: 4,
      consts: [["gdsMapContainer", ""], [3, "mapDidRender", "mapCardDidRender", "tridionData", "pageView", "modalOpen"]],
      template: function GoogleMapComponent_Template(rf, ctx) {
        if (rf & 1) {
          const _r1 = i0.ɵɵgetCurrentView();
          i0.ɵɵelementStart(0, "gds-map-container", 1, 0);
          i0.ɵɵlistener("mapDidRender", function GoogleMapComponent_Template_gds_map_container_mapDidRender_0_listener($event) {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.mapDidRender($event));
          })("mapCardDidRender", function GoogleMapComponent_Template_gds_map_container_mapCardDidRender_0_listener() {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.navigateToCard());
          });
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵproperty("tridionData", ctx.gdsMapContainerData)("pageView", ctx.pageView)("modalOpen", ctx.modalOpen);
          i0.ɵɵattribute("theme", ctx.theme);
        }
      },
      encapsulation: 2
    });
  }
};
GoogleMapComponent = __decorate([AutoSubscription(), __metadata("design:paramtypes", [String, Object, Object, GdsInteractiveMapFilterService, GdsFilterListService, GdsButtonEventsService, PageLabelsResolver, MapPinsService, MapTilesService, GdsInteractiveMapService, ActivatedRoute, GdsCommonUtilityService])], GoogleMapComponent);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GoogleMapComponent, [{
    type: Component,
    args: [{
      selector: 'upr-google-map',
      providers: [GdsInteractiveMapFilterService, MapPinsService],
      standalone: false,
      template: "<gds-map-container\r\n\t#gdsMapContainer\r\n\t[tridionData]=\"gdsMapContainerData\"\r\n\t[pageView]=\"pageView\"\r\n\t[modalOpen]=\"modalOpen\"\r\n\t[attr.theme]=\"theme\"\r\n\t(mapDidRender)=\"mapDidRender($event)\"\r\n\t(mapCardDidRender)=\"navigateToCard()\"\r\n></gds-map-container>\r\n"
    }]
  }], () => [{
    type: undefined,
    decorators: [{
      type: Inject,
      args: ['GoogleMapsApiKey']
    }]
  }, {
    type: undefined,
    decorators: [{
      type: Inject,
      args: [DOCUMENT]
    }]
  }, {
    type: undefined,
    decorators: [{
      type: Inject,
      args: [WINDOW]
    }]
  }, {
    type: i1$2.GdsInteractiveMapFilterService
  }, {
    type: i1$2.GdsFilterListService
  }, {
    type: i2.GdsButtonEventsService
  }, {
    type: i3$1.PageLabelsResolver
  }, {
    type: MapPinsService
  }, {
    type: MapTilesService
  }, {
    type: GdsInteractiveMapService
  }, {
    type: i1.ActivatedRoute
  }, {
    type: i8.GdsCommonUtilityService
  }], {
    mapElement: [{
      type: ViewChild,
      args: ['gdsMapContainer']
    }],
    gdsMapContainerData: [{
      type: Input
    }],
    lat: [{
      type: Input
    }],
    lng: [{
      type: Input
    }],
    zoom: [{
      type: Input
    }],
    streetView: [{
      type: Input
    }],
    mapTypeControl: [{
      type: Input
    }],
    mapType: [{
      type: Input
    }],
    styles: [{
      type: Input
    }],
    mapTypeControlOptions: [{
      type: Input
    }],
    defaultTile: [{
      type: Input
    }],
    pageView: [{
      type: Input
    }],
    modalOpen: [{
      type: Input
    }],
    theme: [{
      type: Input
    }]
  });
})();
class TilePinComponent {
  constructor(tcmPictureSmallWidth, appModal) {
    this.tcmPictureSmallWidth = tcmPictureSmallWidth;
    this.appModal = appModal;
    this.data = {};
    this.tcmPictureSettings = this.tcmPictureSmallWidth;
  }
  closeMapModal(event) {
    event.stopPropagation();
    this.appModal.hide();
  }
  static {
    this.ɵfac = function TilePinComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || TilePinComponent)(i0.ɵɵdirectiveInject('TcmPictureSmallWidth'), i0.ɵɵdirectiveInject(i1$3.AppModalService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: TilePinComponent,
      selectors: [["app-tile-pin"]],
      inputs: {
        data: "data",
        txtReadMore: "txtReadMore"
      },
      standalone: false,
      decls: 1,
      vars: 1,
      consts: [["class", "tile-pin", 4, "ngIf"], [1, "tile-pin"], [1, "media"], [3, "data", "settings", 4, "ngIf"], [1, "map-text"], [3, "innerHTML", 4, "ngIf"], [1, "chevron", 3, "click", "overwriteUrl", "transclude", "ariaLabel"], [3, "innerHtml", 4, "ngIf"], [3, "data", "settings"], [3, "innerHTML"], [3, "innerHtml"]],
      template: function TilePinComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, TilePinComponent_article_0_Template, 7, 6, "article", 0);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", ctx.data);
        }
      },
      dependencies: [i5$1.NgIf],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TilePinComponent, [{
    type: Component,
    args: [{
      selector: 'app-tile-pin',
      standalone: false,
      template: "<article *ngIf=\"data\" class=\"tile-pin\">\r\n\t<div class=\"media\">\r\n\t\t<tcm-picture\r\n\t\t\t*ngIf=\"data?.Content?.TileImage\"\r\n\t\t\t[data]=\"data?.Content?.TileImage\"\r\n\t\t\t[settings]=\"tcmPictureSettings\"\r\n\t\t>\r\n\t\t</tcm-picture>\r\n\t</div>\r\n\t<div class=\"map-text\">\r\n\t\t<h3\r\n\t\t\t*ngIf=\"data?.Content?.Heading\"\r\n\t\t\t[innerHTML]=\"data?.Content?.Heading\"\r\n\t\t></h3>\r\n\t\t<tcm-anchor\r\n\t\t\t(click)=\"closeMapModal($event)\"\r\n\t\t\t[overwriteUrl]=\"data?.PageUrl\"\r\n\t\t\t[transclude]=\"true\"\r\n\t\t\t[ariaLabel]=\"txtReadMore + ' - ' + data?.Content?.Heading\"\r\n\t\t\tclass=\"chevron\"\r\n\t\t>\r\n\t\t\t<span *ngIf=\"txtReadMore\" [innerHtml]=\"txtReadMore\"> </span>\r\n\t\t</tcm-anchor>\r\n\t</div>\r\n</article>\r\n"
    }]
  }], () => [{
    type: undefined,
    decorators: [{
      type: Inject,
      args: ['TcmPictureSmallWidth']
    }]
  }, {
    type: i1$3.AppModalService
  }], {
    data: [{
      type: Input
    }],
    txtReadMore: [{
      type: Input
    }]
  });
})();

// Initialize auto subscription
let GdsMapInteractiveComponent = class GdsMapInteractiveComponent {
  constructor(appEnvService, pageLabelsResolver, route, gdsMapService) {
    this.appEnvService = appEnvService;
    this.pageLabelsResolver = pageLabelsResolver;
    this.route = route;
    this.gdsMapService = gdsMapService;
    this.pageLabelsResolver.get().then(pageLabels => {
      this.pageLabels = pageLabels;
    });
    this.appConfig = this.appEnvService.getEnvVariables('app');
  }
  ngOnInit() {
    if (!this.pageView) {
      this.theme = this.theme ?? get(this.appConfig, 'gds_theme', AvailableGdsThemes[0]);
      this.subscriptions.add(this.gdsMapService.globalMapData$.subscribe(data => {
        this._data = {
          ...data
        };
        this.data = data;
      }));
    }
    this.showModal$ = this.route.queryParams.pipe(switchMap(async params => {
      if (params.mapModal === GdsInteractiveMapModalType.PAGE && this.pageView) {
        return true;
      } else if (params.mapModal && params.mapModal !== GdsInteractiveMapModalType.PAGE && !this.pageView) {
        await this.gdsMapService.loadGlobalMap();
        return true;
      } else {
        return false;
      }
    }));
    this.subscriptions.add(this.showModal$.pipe(distinctUntilChanged()).subscribe(() => {
      if (!this.pageView) {
        this.data = {
          ...this._data
        };
      }
    }));
  }
  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
  static {
    this.ɵfac = function GdsMapInteractiveComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GdsMapInteractiveComponent)(i0.ɵɵdirectiveInject(i1$1.AppEnvironmentService), i0.ɵɵdirectiveInject(i3$1.PageLabelsResolver), i0.ɵɵdirectiveInject(i1.ActivatedRoute), i0.ɵɵdirectiveInject(GdsInteractiveMapService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: GdsMapInteractiveComponent,
      selectors: [["app-gds-map-interactive"]],
      inputs: {
        data: "data",
        pageView: "pageView",
        theme: "theme"
      },
      standalone: false,
      decls: 2,
      vars: 3,
      consts: [[3, "gdsMapContainerData", "url", "lat", "lng", "apiKey", "zoom", "mapType", "pageView", "modalOpen", "theme", 4, "ngIf"], [3, "gdsMapContainerData", "url", "lat", "lng", "apiKey", "zoom", "mapType", "pageView", "modalOpen", "theme"]],
      template: function GdsMapInteractiveComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, GdsMapInteractiveComponent_upr_google_map_0_Template, 2, 11, "upr-google-map", 0);
          i0.ɵɵpipe(1, "async");
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", ctx.data && (ctx.pageView || i0.ɵɵpipeBind1(1, 1, ctx.showModal$)));
        }
      },
      dependencies: [i5$1.NgIf, GoogleMapComponent, i5$1.AsyncPipe],
      encapsulation: 2
    });
  }
};
GdsMapInteractiveComponent = __decorate([AutoSubscription(), __metadata("design:paramtypes", [AppEnvironmentService, PageLabelsResolver, ActivatedRoute, GdsInteractiveMapService])], GdsMapInteractiveComponent);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GdsMapInteractiveComponent, [{
    type: Component,
    args: [{
      selector: 'app-gds-map-interactive',
      standalone: false,
      template: "<upr-google-map\r\n\t*ngIf=\"data && (pageView || (showModal$ | async))\"\r\n\t[gdsMapContainerData]=\"data\"\r\n\t[url]=\" //www.google.com/recaptcha/api.js\"\r\n\t[lat]=\"gdsMapService.lat\"\r\n\t[lng]=\"gdsMapService.lng\"\r\n\t[apiKey]=\"gdsMapService.apiKey\"\r\n\t[zoom]=\"gdsMapService.zoom\"\r\n\t[mapType]=\"gdsMapService.mapType\"\r\n\t[pageView]=\"pageView\"\r\n\t[modalOpen]=\"showModal$ | async\"\r\n\t[theme]=\"theme\"\r\n>\r\n</upr-google-map>\r\n"
    }]
  }], () => [{
    type: i1$1.AppEnvironmentService
  }, {
    type: i3$1.PageLabelsResolver
  }, {
    type: i1.ActivatedRoute
  }, {
    type: GdsInteractiveMapService
  }], {
    data: [{
      type: Input
    }],
    pageView: [{
      type: Input
    }],
    theme: [{
      type: Input
    }]
  });
})();
class GdsInteractiveMapModule {
  static {
    this.ɵfac = function GdsInteractiveMapModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GdsInteractiveMapModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: GdsInteractiveMapModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, GdsButtonEventsModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GdsInteractiveMapModule, [{
    type: NgModule,
    args: [{
      declarations: [GdsInteractiveMapComponent, GdsMapInteractiveComponent, GoogleMapComponent, TilePinComponent],
      imports: [CommonModule, GdsButtonEventsModule],
      exports: [GdsInteractiveMapComponent, GdsMapInteractiveComponent],
      schemas: [CUSTOM_ELEMENTS_SCHEMA]
    }]
  }], null, null);
})();

/*
 * Public API Surface of gds-interactive-map
 */

/**
 * Generated bundle index. Do not edit.
 */

export { GDS_INTERACTIVE_MAP_DEFAULTS, GDS_INTERACTIVE_MAP_REPLACED_DEFAULTS, GdsInteractiveMapComponent, GdsInteractiveMapModule, GdsInteractiveMapService, GdsMapInteractiveComponent };
